function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "10.008",
  cy: "6.55",
  r: "3.375"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.545 7.9v.007V7.9zm9.577 4.23h.016l-.016-.018zM10 .125A9.875 9.875 0 1019.875 10 9.886 9.886 0 0010 .125zm7.05 15.244q-.236.308-.5.6a6.707 6.707 0 00-13.11-.007q-.254-.28-.484-.58a7.378 7.378 0 011.93-3.253 6.165 6.165 0 00-2.123-.4 6.1 6.1 0 00-1.42.195 8.862 8.862 0 01-.21-1.792 2.773 2.773 0 101.63-5.01c-.06 0-.12.01-.18.016a8.858 8.858 0 0114.84.007c-.06 0-.118-.015-.177-.016a2.783 2.783 0 100 5.566v-.006a2.755 2.755 0 001.622-.537 8.86 8.86 0 01-.214 1.79 6.035 6.035 0 00-3.515.182 7.378 7.378 0 011.91 3.244z"
}));